export interface NotificationWindow {
  details: NotificationWindowDetails;
}

export class NotificationWindowDetails {
  header: string;
  text: string;
  okButtonText = 'OK';
  cancelButtonText = 'Cancel';

  windowClass = 'position-relative';
  headerClass = 'header-wrapper h4 pb-2';
  contentClass = 'content-wrapper main-text-font p-3';
  footerClass = 'footer-wrapper';

  okButtonClass = 'styled primary';
  cancelButtonClass = 'styled secondary me-1';

  buttonsReverse = false;
}
